import * as React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import { commonPDFStyles, PDF_COLORS } from '../styles/pdfStyles';
import { typographyStyles, specializedTypography } from '../styles/typography';
import { formatDateForPDF } from '../utils/dataFormatters';

/**
 * PDF Header Component
 * 
 * Replaces HeaderDocument component with @react-pdf/renderer equivalent.
 * Handles hospital branding, logo, and contact information.
 */

interface PDFHeaderProps {
  hospitalName: string;
  logoBlob: string;
  locale: string;
  address: string;
  city: string;
  email: string;
  phone: string;
  size?: 'A4' | 'ticket';
  title?: string | React.ReactNode;
}

export const PDFHeader: React.FC<PDFHeaderProps> = ({
  hospitalName,
  logoBlob,
  locale,
  address,
  city,
  email,
  phone,
  size = 'A4',
  title,
}) => {
  // Process logo - always data:image format
  const logoBase64 = logoBlob || '';

  // Only render for A4 size
  if (size !== 'A4') {
    return null;
  }

  return (
    <View style={[commonPDFStyles.header, { flexDirection: 'column' }]}>
      {/* Top Row: Logo and Hospital Info */}
      <View style={{ flexDirection: 'row', width: '100%' }}>
        {/* Left side - Logo */}
        <View style={[commonPDFStyles.headerLeft, { alignItems: 'flex-start'}]}>
          {logoBase64 && (
            <Image
              src={logoBase64}
              style={commonPDFStyles.logo}
            />
          )}
        </View>

        {/* Right side - Hospital Information */}
        <View style={commonPDFStyles.headerRight}>
          {/* Hospital Name */}
          <Text style={[specializedTypography.hospitalName, { textAlign: 'right' }]}>
            {hospitalName}
          </Text>

          {/* Address */}
          <Text style={[specializedTypography.hospitalAddress, { textAlign: 'right' }]}>
            {address}
          </Text>

          {/* Phone */}
          <Text style={[specializedTypography.hospitalAddress, { textAlign: 'right' }]}>
            {phone}
          </Text>

          {/* Email */}
          <Text style={[specializedTypography.hospitalAddress, { textAlign: 'right' }]}>
            {email}
          </Text>

          {/* Date and Location */}
          <View style={{ marginTop: 16 }}>
            <Text style={[specializedTypography.hospitalAddress, { textAlign: 'right' }]}>
              {city}, le {formatDateForPDF(new Date(), locale)}
            </Text>
          </View>
        </View>
      </View>

      {/* Title Section */}
      {title && (
        <View style={{ width: '100%', marginTop: 2 }}>
          <Text style={[typographyStyles.h3, { textAlign: 'center' }]}>
            {typeof title === 'string' ? title : String(title)}
          </Text>
        </View>
      )}
    </View>
  );
};

export default PDFHeader;
